import { createRouter, createWebHashHistory } from 'vue-router'
import request from '@/util/request'
import {ElMessage} from "element-plus";
import requestUtil from "@/util/request";

const routes = [
  // {
  //   path: '/',
  //   name: '主页',
  //   redirect: '/index',
  // },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: ()=>import('../views/error/notFound.vue') },
  {
    path: '/',
    name: '首页',
    component: () => import('../views/index/index.vue'),
  },
  {
    path:'/app',
    name:'移动端',
    component:()=>import('../views/app/index.vue'),
    children: [
      {
        path:'login',
        name:'移动端登录',
        component:()=>import('../views/app/login/index.vue'),
      },
      {
        path:'index',
        name:'移动端首页',
        component:()=>import('../views/app/index/index.vue'),
      }
    ]
  },
  {
    path:'/login',
    name:'登录',
    component:()=>import('../views/index/login/Login.vue'),
  },
  {
    path: '/management',
    name:'后台管理系统',
    component:()=>import('../views/ManagementSystem/layout/index.vue'),
    // redirect: '/management/managementIndex',
    children:[
      {
        path:'managementIndex',
        //这里的path不能加/，加了/就相当于 相对上一级的路径，
        // 例如/managementIndex，先访问上一级的/management，地址为：http://localhost:8080/#/management
        // 再访问子路由/managementIndex，地址为：http://localhost:8080/#/managementIndex 这里的managementIndex是相对于management的路径
        // 如果直接输入完整路径http://localhost:8080/#/management/managementIndex,相当于在management中再次寻找management子路由，找不到
        // 需要访问完整路径的话，要把/去掉，就可以使用http://localhost:8080/#/management/managementIndex访问了
        name:'后台首页',
        component:()=>import('../views/ManagementSystem/index/index.vue'),
      },
      {
        path:'sys',
        name:'系统管理',
        component:()=>import('../views/ManagementSystem/sys/index.vue'),
        children:[
          {
            path:'roleCtrl',
            name:'角色管理',
            component:()=>import('../views/ManagementSystem/sys/roleCtrl/index.vue'),
          },
          {
            path:'menuCtrl',
            name:'菜单管理',
            component:()=>import('../views/ManagementSystem/sys/menuCtrl/index.vue'),
          },
          {
            path:'userCtrl',
            name:'用户管理',
            component:()=>import('../views/ManagementSystem/sys/userCtrl/index.vue'),
          },
          {
            path:'userCenterCtrl',
            name:'个人中心',
            component:()=>import('../views/ManagementSystem/sys/userCenter/index.vue'),
          },
          {
            path:'classTimeSet',
            name:'系统课时设置',
            component:()=>import('../views/ManagementSystem/sys/classTimeSet/index.vue'),
          },
          {
            path:'professionSet',
            name:'系统专业设置',
            component:()=>import('../views/ManagementSystem/sys/professionSet/index.vue'),
          },
          {
            path:'readySignAutoSet',
            name:'编班代码设置',
            component:()=>import('../views/ManagementSystem/sys/readySignAutoSet/index.vue'),
          }

        ]
      },
      {
        path:'select',
        name:'查询',
        component:()=>import('../views/ManagementSystem/select/index.vue'),
        children:[
          {
            path:'one',
            name:'单一查询',
            component:()=>import('../views/ManagementSystem/select/one/index.vue'),
          },
          {
            path:'many',
            name:'综合查询',
            component:()=>import('../views/ManagementSystem/select/many/index.vue'),
          },
        ]
      },
      {
        path:'signCtrl',
        name:'总报名管理',
        component:()=>import('../views/ManagementSystem/signCtrl/index.vue'),
        children: [
          {
            path:'registration',
            name:'报名信息库',
            component:()=>import('../views/ManagementSystem/signCtrl/registration/index.vue'),
          },
          {
            path:'readySign',
            name:'预报名管理',
            component:()=>import('../views/ManagementSystem/signCtrl/readySign/index.vue'),
          },
        ]
      },
      {
        path:'classCtrl',
        name:'班级管理',
        component:()=>import('../views/ManagementSystem/classCtrl/index.vue'),
        children:[
          {
            path:'baseInfoManagement',
            name:'班级创建',
            component:()=>import('../views/ManagementSystem/classCtrl/baseInfo/index.vue'),
          },
          {
            path:'certificateStatistics',
            name:'班级证书统计',
            component:()=>import('../views/ManagementSystem/classCtrl/certificateStatistics/index.vue'),
          }
        ]
      },
      {
        path:'outCertificateCtrl',
        name:'出证管理',
        component:()=>import('../views/ManagementSystem/outCertificateCtrl/index.vue'),
        children:[
          {
            path:'outPlan',
            name:'出证计划',
            component:()=>import('@/views/ManagementSystem/outCertificateCtrl/outPlan/index.vue'),
          },
        ]
      },
      {
        path:'receiveCtrl',
        name:'领证管理',
        component:()=>import('../views/ManagementSystem/receiveCtrl/index.vue'),
        children:[
          {
            path:'ctrl',
            name:'领证单操作',
            component:()=>import('@/views/ManagementSystem/receiveCtrl/ctrl/index.vue'),
          },
          {
            path:'receive',
            name:'领证',
            component:()=>import('@/views/ManagementSystem/receiveCtrl/receive/index.vue'),
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

//路由守卫
router.beforeEach(async(to, from, next) => {
  if (to.path==='/' || to.path === '/login' || to.path ==='/app/login') {
    next()
  }
  else{
    let error_path=""
    let pathType=""
    if(to.path ==='/app/index'){
      error_path="/app/login"
      pathType="app"
    }
    else if(to.path.startsWith("/management")){
      error_path="/login"
      pathType="management"
    }
    else{
      error_path="/"
      pathType="other"
    }
    const token = window.sessionStorage.getItem('token')
    if(!token){
          next(error_path)
          ElMessage({
            type:'error',
            message:'请先登录'
          })
    }else{
        const auth=await checkAuth()
        if(pathType==="app"){
          if(auth!='stu'){
            next(error_path)
            ElMessage({
              type:'error',
              message:'你没有权限访问！！！'
            })
          }else{
            next()
          }
        }else if(pathType==="management"){
          if(auth!='tea'){
            next(error_path)
            ElMessage({
              type:'error',
              message:'你没有权限访问！！！'
            })
          }else{
            const getPathList=await getMenuPathByAuth()
            const pathList = getPathList.map(item => `/management${item}`);
            pathList.push('/management/managementIndex')
            pathList.push('/management/sys/userCenterCtrl')
            pathList.push('/management')
            pathList.push('')
            if(pathList.includes(to.path)){
              next()
            }else{
              next('/management/managementIndex')
              ElMessage({
                type:'error',
                message:'你没有访问这个菜单的权限！！！'
              })
            }
          }
        }else{
          next(error_path)
        }

    }
  }
})

const getMenuPathByAuth=async()=>{
  try{
    const result = await requestUtil.post("menu/menuInit");
    let data=result.data
    if (data.code == 200) {
      return getMenuPaths(data.menuList);
    }
    else{
      return []
    }
  }catch (err){
    return []
  }

}

const getMenuPaths=(data, parentPath = '')=> {
  const paths = [];
  data.forEach(item => {
    const currentPath = parentPath === ''? item.path : `${parentPath}${item.path}`;
    paths.push(currentPath);
    if (item.children && item.children.length > 0) {
      const childPaths = getMenuPaths(item.children, currentPath);
      paths.push(...childPaths);
    }
  });
  return paths;
}

const checkAuth=async()=>{
  try{
    const result = await requestUtil.get("user/checkAuth");
    if (result.data.code == 200){
      return result.data.auth;
    }else{
      return "ban"
    }
  }catch (err){
    return "ban"
  }
}

export default router
